<template>
  <div class="dashboard-widget">
    <h6 class="text-primary">Enquiry Follow Ups</h6>
    <template v-if="enquiries.length">
      <router-link
        v-for="enq in enquiries"
        :key="enq.id"
        :to="{ name: 'Enquiry Overview', params: { id: enq.id } }"
        tag="div"
        class="enquiry-item md-layout enquiry-follow-up"
      >
        <div class="md-layout-item md-size-40 customer">
          {{ enq.customer }}
        </div>
        <div class="md-layout-item md-size-30 follow-up-date">
          {{ enq.follow_up | formatDateShort }}
        </div>
        <div
          class="md-layout-item md-size-30 heat text-right"
          :class="ratingColour(enq.heat)"
        >
          <i v-for="(n, i) in enq.heat" :key="i" class="fas fa-star"></i>
        </div>
      </router-link>
    </template>
    <template v-else>
      <p v-if="loaded">
        <strong>Good Job!</strong> No Follow Ups needed today.
      </p>
    </template>
  </div>
</template>

<script>
import enquiryApi from "@/services/api/enquiry";

export default {
  name: "WidgetEnquiries",
  data() {
    return {
      loaded: false,
      enquiries: []
    };
  },

  computed: {},

  methods: {
    ratingColour(heat) {
      let temp = "";
      switch (heat) {
        case 1:
        case 2:
          temp = "cool";
          break;
        case 3:
          temp = "medium";
          break;
        case 4:
        case 5:
          temp = "hot";
          break;
      }
      return temp;
    }
  },

  created() {
    enquiryApi.getEnquiryFollowUps().then(response => {
      this.enquiries = response.data.enquiries;
      this.loaded = true;
    });
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";

h6 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.enquiry-follow-up {
  padding: 3px 0px;
  border-bottom: 1px solid #d2d2d2;
  cursor: pointer;
}
.actions {
  .action-button {
    width: 24px;
    min-width: 24px;
    height: 24px;
    margin: 0px;
  }
}
</style>
